<template>
	<span class="font-bold text-idrive-dark underline underline-offset-2">
		<slot />
	</span>
</template>
